import React from "react";
import PropTypes from "prop-types";
import LeftButtonGroup from "./LeftButtonGroup";
import RightButtonGroup from "./RightButtonGroup";

const ListPageHeader = ({
  title,
  onAdd,
  toggleFilterModal,
  deleteSelected,
  onSearch,
  isExpanded,
  setIsExpanded,
  onExport,
}) => {
  return (
    <div className="flex flex-col border-y border-gray-300">
      <div className="flex items-center">
        {title && (
          <h2 className="p-2 font-medium whitespace-nowrap">{title}</h2>
        )}

        <LeftButtonGroup
          onAdd={onAdd}
          deleteSelected={deleteSelected}
          onSearch={onSearch}
        />

        <div className="ml-auto">
          <RightButtonGroup
            toggleFilterModal={toggleFilterModal}
            isExpanded={isExpanded}
            setIsExpanded={setIsExpanded}
            onExport={onExport}
          />
        </div>
      </div>
    </div>
  );
};

ListPageHeader.propTypes = {
  title: PropTypes.string,
  onAdd: PropTypes.func,
  toggleFilterModal: PropTypes.func,
  deleteSelected: PropTypes.func,
  onSearch: PropTypes.func,
  isExpanded: PropTypes.bool,
  setIsExpanded: PropTypes.func,
  onExport: PropTypes.func,
};

export default ListPageHeader;
